module.exports = __webpack_public_path__ + "static/media/slider3.08e456e9.png";